module.exports = __webpack_public_path__ + "static/assets/7264c0b67b765f818b43510d45822a3f.png";